/*
 * MMC: autoplay for Prestige carousels (scroll-carousel[data-suit-autoplay="<milliseconds>"]), as the legacy Suit owl
 * carousels (related products: one product every 3 seconds, back to the first one at the end, paused on hover).
 *
 * Paused while hovered, focused or touched, while off screen, and disabled when the visitor prefers reduced motion.
 * Cards added later (e.g. other colors loaded asynchronously) are picked up, since the cells are read at every step.
 */
(() => {
  if (window.__suitCarouselAutoplay) {
    return;
  }

  window.__suitCarouselAutoplay = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (carousel) => {
    if (carousel.__suitAutoplay) {
      return;
    }

    carousel.__suitAutoplay = true;

    const delay = parseInt(carousel.dataset.suitAutoplay, 10) || 3000;
    // Hover / focus on the whole list, arrows included
    const area = carousel.closest('product-list') || carousel;
    let paused = false;
    let visible = false;
    let timer = null;

    const atEnd = () => carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2;

    const step = () => {
      if (paused || !visible || reducedMotion.matches || document.hidden || carousel.cells.length < 2 || !carousel.isScrollable) {
        return;
      }

      if (atEnd()) {
        carousel.select(0);
      } else {
        carousel.select(Math.min(carousel.selectedIndex + 1, carousel.cells.length - 1));
      }
    };

    const restart = () => {
      clearInterval(timer);
      timer = setInterval(step, delay);
    };

    const pause = () => {
      paused = true;
    };

    const resume = () => {
      paused = false;
      // A full delay after the interaction before the next step
      restart();
    };

    area.addEventListener('mouseenter', pause);
    area.addEventListener('mouseleave', resume);
    area.addEventListener('focusin', pause);
    area.addEventListener('focusout', (event) => {
      if (!area.contains(event.relatedTarget)) {
        resume();
      }
    });
    area.addEventListener('touchstart', pause, { passive: true });
    area.addEventListener('touchend', resume, { passive: true });

    new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
    }).observe(carousel);

    restart();
  };

  const init = () => document.querySelectorAll('scroll-carousel[data-suit-autoplay]').forEach(setup);

  // scroll-carousel is defined by the theme script: wait for it before using its API
  customElements.whenDefined('scroll-carousel').then(() => {
    init();
    // Sections re-rendered by the theme editor
    document.addEventListener('shopify:section:load', init);
  });
})();
